<template>
    <section id="testimonios" class="pt-16">
        <div class="container mx-auto">
            <div class="text-center">
                <p class="text-sm font-semibold tracking-wide text-[#84509A] mb-2">Testimonios</p>
                <h2 class="mt-2 text-3xl sm:text-4xl font-extrabold text-slate-900">
                    Conoce la experiencia de nuestros clientes
                </h2>
            </div>

            <!-- Desktop -->
            <div class="mx-auto px-4 py-12 font-sans">

                <div class="flex flex-col md:flex-row justify-end items-end mb-8 gap-4">
                    <div class="flex gap-3">
                        <div
                            class="js-prev cursor-pointer flex items-center justify-center w-8 h-8 rounded-full bg-gray-800 text-white hover:text-white transition-all duration-300 focus:outline-none border border-gray-700 hover:bg-[#6f3e80]">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M15 19l-7-7 7-7" />
                            </svg>
                        </div>

                        <div
                            class="js-next cursor-pointer flex items-center justify-center w-8 h-8 rounded-full bg-gray-800 text-white hover:text-white transition-all duration-300 focus:outline-none border border-gray-700 hover:bg-[#6f3e80]">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 5l7 7-7 7" />
                            </svg>
                        </div>
                    </div>
                </div>

                <swiper ref="mySwiper" :options="swiperOptions" class="w-full pb-10">
                    <swiper-slide v-for="(item, index) in testimonials" :key="index">

                        <div
                            class="bg-gray-900 rounded-2xl p-8 flex flex-col text-white border border-gray-800 shadow-xl hover:border-purple-500/30 transition-colors duration-300">

                            <div>
                                <div class="flex justify-between items-start mb-6">
                                    <div class="relative w-14 h-14">
                                        <div
                                            class="absolute inset-0 bg-purple-600 rounded-full opacity-20 transform scale-110">
                                        </div>
                                        <img :src="item.avatar" :alt="item.name"
                                            class="relative w-full h-full rounded-full object-cover border-2 border-purple-500 z-10" />
                                    </div>

                                    <div class="text-purple-500 opacity-80">
                                        <img src="https://wize.pe/wp-content/uploads/2024/12/icon-1.png" alt="">
                                    </div>
                                </div>

                                <div class="h-[80px]">
                                    <h3 class="text-lg font-bold text-white mb-1">{{ item.name }}</h3>
                                    <p class="text-[13px] text-[#FFFFFF99] font-medium mt-3">{{ item.role }}</p>
                                </div>
                            </div>

                            <p class="text-[14px] font-medium text-gray-300 leading-relaxed mt-1 mb-0">
                                "{{ item.quote }}"
                            </p>

                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    name: 'TestimonialSlider',
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.js-next',
                    prevEl: '.js-prev'
                },
                loop: true,
                watchOverflow: true,
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 24
                    }
                }
            },
            testimonials: [
                {
                    name: "Karen S.",
                    role: "Jefa Administrativa",
                    avatar: "https://wize.pe/wp-content/uploads/2024/12/user-1.svg",
                    quote: "Desde que activamos ZET, nos despreocupamos por completo. Cumplimos con INDECOPI y la gestión de reclamos está bajo control."
                },
                {
                    name: "José M.",
                    role: "Gerente de Operaciones",
                    avatar: "https://wize.pe/wp-content/uploads/2024/12/user-2.svg",
                    quote: "La mejor decisión para simplificar trámites. El plan de ZET fue la mejor inversión para asegurar nuestra tranquilidad legal."
                },
                {
                    name: "Ricardo C.",
                    role: "Asesor Legal",
                    avatar: "https://wize.pe/wp-content/uploads/2024/12/user-4.svg",
                    quote: "Recomiendo ZET a todos mis clientes. Es la forma más rápida y segura de tener el Libro de Reclamaciones digital al día y listo para auditorías."
                },
                {
                    name: "Ana R.",
                    role: "Marketing Digital",
                    avatar: "https://wize.pe/wp-content/uploads/2024/12/user-3.svg",
                    quote: "Nos encanta que el Libro de Reclamaciones tenga nuestra propia URL . Mantiene la imagen de marca mientras cumplimos la ley."
                },
                {
                    name: "Miguel S.",
                    role: "Servicio al Cliente",
                    avatar: "https://wize.pe/wp-content/uploads/2024/12/user-2.svg",
                    quote: "El sistema de ZET es intuitivo y el soporte técnico es excelente. Ahora podemos dar seguimiento a cada queja sin que se pierda ninguna."
                }
            ]
        }
    }
}
</script>

<style scoped>
/* Estilos esenciales de Swiper */
.swiper-container {
    overflow: hidden;
}

.swiper-slide {
    height: auto;
    display: flex;
}

/* Estado deshabilitado de botones */
/* .js-prev.swiper-button-disabled,
.js-next.swiper-button-disabled {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
} */
</style>